// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v2-poker-atmosphere {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.v2-poker-motif {
  position: absolute;
  display: block;
  color: #c084fc;
  opacity: var(--motif-opacity, 0.34);
  filter: blur(var(--motif-blur, 1.4px));
  transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg));
  animation: v2-poker-drift 18s ease-in-out infinite;
  animation-delay: var(--motif-delay, 0s);
  will-change: transform;
  pointer-events: none;
}
.v2-poker-motif svg {
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;
}
.v2-poker-motif--chip {
  color: #a855f7;
}
.v2-poker-motif--card {
  color: #e9d5ff;
}
.v2-poker-motif--dice {
  color: #d8b4fe;
}
.v2-poker-motif--spade, .v2-poker-motif--club {
  color: #c084fc;
}
.v2-poker-motif--heart, .v2-poker-motif--diamond {
  color: #f0abfc;
}

.v2-poker-atmosphere .v2-poker-motif--spade svg path,
.v2-poker-atmosphere .v2-poker-motif--heart svg path,
.v2-poker-atmosphere .v2-poker-motif--diamond svg path,
.v2-poker-atmosphere .v2-poker-motif--club svg path,
.v2-poker-atmosphere .v2-poker-motif--club svg circle,
.v2-poker-atmosphere .v2-poker-motif--card svg rect,
.v2-poker-atmosphere .v2-poker-motif--dice svg rect {
  fill: currentColor;
}

.v2-poker-atmosphere .v2-poker-motif--card svg path,
.v2-poker-atmosphere .v2-poker-motif--dice svg circle {
  fill: #1a0f2e;
}

.v2-poker-atmosphere .v2-poker-motif--chip svg * {
  fill: none;
}

@keyframes v2-poker-drift {
  0%, 100% {
    transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg)) translate3d(0, 0, 0);
  }
  50% {
    transform: translate(-50%, -50%) rotate(calc(var(--motif-rotate, 0deg) + 4deg)) translate3d(8px, -14px, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-poker-motif {
    animation: none;
  }
}
@media screen and (max-width: 767.98px) {
  .v2-poker-motif {
    transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg)) scale(0.8);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PokerAtmosphere/PokerAtmosphere.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,sCAAA;EACA,kEAAA;EACA,kDAAA;EACA,uCAAA;EACA,sBAAA;EACA,oBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,cAAA;AAFJ;AAKE;EAEE,cAAA;AAJJ;AAOE;EAEE,cAAA;AANJ;;AAUA;;;;;;;EAOE,kBAAA;AAPF;;AAUA;;EAEE,aAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AAUA;EACE;IAEE,uFAAA;EARF;EAUA;IACE,0GAAA;EARF;AACF;AAYA;EACE;IACE,eAAA;EAVF;AACF;AAaA;EACE;IACE,6EAAA;EAXF;AACF","sourcesContent":[".v2-poker-atmosphere {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.v2-poker-motif {\n  position: absolute;\n  display: block;\n  color: #c084fc;\n  opacity: var(--motif-opacity, 0.34);\n  filter: blur(var(--motif-blur, 1.4px));\n  transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg));\n  animation: v2-poker-drift 18s ease-in-out infinite;\n  animation-delay: var(--motif-delay, 0s);\n  will-change: transform;\n  pointer-events: none;\n\n  svg {\n    width: 100%;\n    height: 100%;\n    display: block;\n    overflow: visible;\n  }\n\n  &--chip {\n    color: #a855f7;\n  }\n\n  &--card {\n    color: #e9d5ff;\n  }\n\n  &--dice {\n    color: #d8b4fe;\n  }\n\n  &--spade,\n  &--club {\n    color: #c084fc;\n  }\n\n  &--heart,\n  &--diamond {\n    color: #f0abfc;\n  }\n}\n\n.v2-poker-atmosphere .v2-poker-motif--spade svg path,\n.v2-poker-atmosphere .v2-poker-motif--heart svg path,\n.v2-poker-atmosphere .v2-poker-motif--diamond svg path,\n.v2-poker-atmosphere .v2-poker-motif--club svg path,\n.v2-poker-atmosphere .v2-poker-motif--club svg circle,\n.v2-poker-atmosphere .v2-poker-motif--card svg rect,\n.v2-poker-atmosphere .v2-poker-motif--dice svg rect {\n  fill: currentColor;\n}\n\n.v2-poker-atmosphere .v2-poker-motif--card svg path,\n.v2-poker-atmosphere .v2-poker-motif--dice svg circle {\n  fill: #1a0f2e;\n}\n\n.v2-poker-atmosphere .v2-poker-motif--chip svg * {\n  fill: none;\n}\n\n@keyframes v2-poker-drift {\n  0%,\n  100% {\n    transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg)) translate3d(0, 0, 0);\n  }\n  50% {\n    transform: translate(-50%, -50%) rotate(calc(var(--motif-rotate, 0deg) + 4deg))\n      translate3d(8px, -14px, 0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .v2-poker-motif {\n    animation: none;\n  }\n}\n\n@media screen and (max-width: 767.98px) {\n  .v2-poker-motif {\n    transform: translate(-50%, -50%) rotate(var(--motif-rotate, 0deg)) scale(0.8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
